export const CREATE_NEW_MEMBER_ADMIN_ERROR = 'management/clinicmember/CREATE_NEW_MEMBER_ADMIN_ERROR'
export const CREATE_NEW_MEMBER_ADMIN_SUCCESS = 'management/clinicmember/CREATE_NEW_MEMBER_ADMIN_SUCCESS'
export const CREATE_NEW_MEMBER_ADMIN = 'management/clinicmember/CREATE_NEW_MEMBER_ADMIN'

export const CREATE_NEW_MEMBER_PROVIDER = 'management/clinicmember/CREATE_NEW_MEMBER_PROVIDER'
export const CREATE_NEW_MEMBER_PROVIDER_ERROR = 'management/clinicmember/CREATE_NEW_MEMBER_PROVIDER_ERROR'
export const CREATE_NEW_MEMBER_PROVIDER_SUCCESS = 'management/clinicmember/CREATE_NEW_MEMBER_PROVIDER_SUCCESS'

export const EDIT_ADMIN_MEMBER = 'management/clinicmember/EDIT_ADMIN_MEMBER'
export const EDIT_ADMIN_MEMBER_SUCCESS = 'management/clinicmember/EDIT_ADMIN_MEMBER_SUCCESS'
export const EDIT_ADMIN_MEMBER_ERROR = 'management/clinicmember/EDIT_ADMIN_MEMBER_ERROR'

export const EDIT_PROVIDER_MEMBER = 'management/clinicmember/EDIT_PROVIDER_MEMBER'
export const EDIT_PROVIDER_MEMBER_SUCCESS = 'management/clinicmember/EDIT_PROVIDER_MEMBER_SUCCESS'
export const EDIT_PROVIDER_MEMBER_ERROR = 'management/clinicmember/EDIT_PROVIDER_MEMBER_ERROR'

export const SET_ADMIN_PROFILE_IMG = 'management/clinicmember/SET_ADMIN_PROFILE_IMG'
export const SET_ADMIN_PROFILE_IMG_SUCCESS = 'management/clinicmember/SET_ADMIN_PROFILE_IMG_SUCCESS'
export const SET_ADMIN_PROFILE_IMG_ERROR = 'management/clinicmember/SET_ADMIN_PROFILE_IMG_ERROR'

export const SET_PROVIDER_PROFILE_IMG = 'management/clinicmember/SET_PROVIDER_PROFILE_IMG'
export const SET_PROVIDER_PROFILE_IMG_SUCCESS = 'management/clinicmember/SET_PROVIDER_PROFILE_IMG_SUCCESS'
export const SET_PROVIDER_PROFILE_IMG_ERROR = 'management/clinicmember/SET_PROVIDER_PROFILE_IMG_ERROR'

export const VALIDATE_PHONE_NUMBER = 'management/clinicmember/VALIDATE_PHONE_NUMBER'
export const VALIDATE_PHONE_NUMBER_SUCCESS = 'management/clinicmember/VALIDATE_PHONE_NUMBER_SUCCESS'
export const VALIDATE_PHONE_NUMBER_ERROR = 'management/clinicmember/VALIDATE_PHONE_NUMBER_ERROR'

export const SET_PAGE_STATUS = 'management/clinicmember/SET_PAGE_STATUS'
export const SET_NEW_MEMBER_PAGE_ERROR = 'management/clinicmember/SET_NEW_MEMBER_PAGE_ERROR'
export const SET_IS_USER_DATA_CHANGED_VALUE = 'management/clinicmember/SET_IS_USER_DATA_CHANGED_VALUE'
export const SET_EDITED_PROVIDER_MEMBER_DATA_VALUE = 'management/clinicmember/SET_EDITED_PROVIDER_MEMBER_DATA_VALUE'
export const SET_EDITED_ADMIN_MEMBER_DATA_VALUE = 'management/clinicmember/SET_EDITED_ADMIN_MEMBER_DATA_VALUE'

export const RESET_NEW_MEMBER_PAGE = 'management/clinicmember/RESET_NEW_MEMBER_PAGE'
